<form #remarkForm="ngForm" class="form-container">
  <div class="form-header">
    <div class="form-breadcrumb">
      <h3><a [routerLink]="['/remark']">Remark</a> > {{ remark.name || 'Create' }}</h3>
    </div>
    <div class="form-actions">
      <button *ngIf="!isFormDisabled" type="submit" mat-flat-button color="primary" (click)="save(remarkForm.valid)">
        <mat-icon>save</mat-icon> Save
      </button>
      <button *ngIf="isFormDisabled" type="button" mat-stroked-button (click)="edit()">
        <mat-icon>edit</mat-icon> Edit
      </button>
      <button *ngIf="isFormDisabled" type="button" mat-flat-button color="primary" (click)="create()">
        <mat-icon>add</mat-icon> Create
      </button>
      <button *ngIf="!isFormDisabled" type="button" mat-stroked-button (click)="discardChanges()">Discard</button>
    </div>
  </div>
  <div class="form-card">
    <fieldset [disabled]="isFormDisabled">
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Name</mat-label>
            <input #name="ngModel" type="text" matInput name="name" [(ngModel)]="remark.name" required>
            <mat-error *ngIf="name.invalid && name.touched">Name is required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Description</mat-label>
            <textarea #des="ngModel" rows="4" matInput name="description" [(ngModel)]="remark.description" required></textarea>
            <mat-error *ngIf="des.invalid && des.touched">Description is required</mat-error>
          </mat-form-field>
        </div>
      </div>
    </fieldset>
  </div>
  <app-audit-log-viewer model="remark" [recordId]="remark.id"></app-audit-log-viewer>
</form>
